import { SanityLanguage } from '@/types/language';

export function getLangCode(lang: string): SanityLanguage {
	switch (lang) {
		case 'cs':
			return 'cs_CZ';
		case 'sk':
			return 'sk_SK';
		case 'hu':
			return 'hu_HU';
		default:
			throw new Error(`Unsupported language: ${lang}`);
	}
}

export const sanityLanguage: SanityLanguage = getLangCode(process.env.NEXT_PUBLIC_LANGUAGE);
